import React, {ReactNode} from 'react';
import {observer} from 'mobx-react';
import {stylesheet} from 'typestyle';

import {GreyColor, WhiteColorFaded70} from '../../styles/colors';
import Store, {DiagramMode} from '../../stores/store';
import {KpiSwitcher} from './KpiSwitcher';
import {AbsoluteOrRelativeDropdown} from './AbsoluteOrRelativeDropdown';
import DateRangeSelector from '../DateRangeSelector';
import {DiagramModeChanger} from './DiagramModeChanger';
import {TogglableDateCompareRangeSelector} from './TogglableDateCompareRangeSelector';
import {I18n} from '../../i18n/i18n';

interface ExplorerParamsBarProps {
    store: Store;
}

export const ExplorerParamsBar: React.FunctionComponent<ExplorerParamsBarProps> = observer((props) => {
    const {store} = props;
    const {
        mainDateRange,
        setMainDateRange,
        compareDateRange,
        setCompareDateRange,
        allowDateCompareRange,
        setAllowDateCompareRange,
    } = store.timeIntervalStore;

    store.lineDiagramStore.updateDiagram;

    const diagramParams: ReactNode[] = [];
    if (store.diagramMode !== DiagramMode.None && store.lineDiagramStore.diagramData.length) {
        const {getChartableColumnsForKpiSwitcher} = store.selectorTableStore;
        const {
            changeKpiVariable,
            changeDiagramYScale,
            diagramYScaleAbsolute,
            requestedNormalDiagrams,
            requestedChannelDiagrams,
        } = store.lineDiagramStore;
        const diagrams = [...requestedNormalDiagrams, ...requestedChannelDiagrams];
        diagramParams.push(
            <div key="switcher">
                <ExplorerTitle>
                    <I18n i18nKey="kpiSwitcher" />
                </ExplorerTitle>
                <div>
                    <KpiSwitcher getChartableColumns={getChartableColumnsForKpiSwitcher} diagrams={diagrams} changeKpiVariable={changeKpiVariable} />
                </div>
            </div>
        );
        diagramParams.push(
            <div key="abs_rel">
                <ExplorerTitle>
                    <I18n i18nKey="absRelSwitcher" />
                </ExplorerTitle>
                <div>
                    <AbsoluteOrRelativeDropdown isAbsolute={diagramYScaleAbsolute} setIsAbsolute={changeDiagramYScale} />
                </div>
            </div>
        );
    }

    return (
        <div className={paramsCss.root}>
            <div>
                <ExplorerTitle>
                    <I18n i18nKey="date.mainRange" />
                </ExplorerTitle>
                <DateRangeSelector
                    namePrefix="diagram"
                    startDate={mainDateRange.startDate}
                    endDate={mainDateRange.endDate}
                    onDatesChange={setMainDateRange}
                />
            </div>
            <div>
                <ExplorerTitle>
                    <I18n i18nKey="date.compareRange" />
                </ExplorerTitle>
                <TogglableDateCompareRangeSelector
                    dateRange={compareDateRange}
                    setDateRange={setCompareDateRange}
                    mainDateRange={mainDateRange}
                    allowDateRange={allowDateCompareRange}
                    setAllowDateRange={setAllowDateCompareRange}
                />
            </div>
            <div>
                <ExplorerTitle>
                    <I18n i18nKey="diagram.modeSwitcher" />
                </ExplorerTitle>
                <DiagramModeChanger store={store} />
            </div>
            {diagramParams}
        </div>
    );
});

interface TitleProps {
    children?: React.ReactNode;
}

export const ExplorerTitle: React.FunctionComponent<TitleProps> = (props) => {
    return <div className={paramsCss.title}>{props.children}</div>;
};

const paramsCss = stylesheet({
    title: {
        fontSize: 12,
        color: GreyColor,
    },
    root: {
        zIndex: 200,
        pointerEvents: 'none',
        paddingLeft: 15,
        $nest: {
            '& > div': {
                display: 'inline-block',
                verticalAlign: 'top',
                margin: '.5rem 5px 1rem',
            },
            '& > div > div > div': {
                backgroundColor: WhiteColorFaded70,
                textAlign: 'left',
            },
            '& select': {
                backgroundColor: 'transparent',
            },
        },
    },
});



// WEBPACK FOOTER //
// ./src/views/ExplorerParamsBar/ExplorerParamsBar.tsx